/* NEYA — animations discrètes */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var de = document.documentElement;

  /* 1. Accueil : léger décalage de la photo principale au scroll */
  var hero = document.querySelector('.neya-hero');
  var img = hero && hero.querySelector('.neya-hero__image');
  if (img) {
    var ticking = false;
    var update = function () {
      ticking = false;
      var r = hero.getBoundingClientRect();
      if (r.bottom < 0) return;
      var y = Math.min(Math.max(-r.top, 0), hero.offsetHeight);
      img.style.setProperty('--neya-py', (y * 0.18).toFixed(1) + 'px');
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* 2. Apparition au scroll */
  var small = window.matchMedia && window.matchMedia('(max-width: 560px)').matches;
  var selectors = [
    '.neya-heading', '.neya-bundle-callout', '.neya-feature__media', '.neya-feature__content',
    '.neya-cleanser__media', '.neya-cleanser__content', '.neya-values__grid article',
    '.neya-commitments__grid article', '.neyaview__copy', '.neyaview__stage'
  ];
  if (!small) selectors.push('.neya-product-card');
  if ('IntersectionObserver' in window) {
    var els = document.querySelectorAll(selectors.join(','));
    if (els.length) {
      de.classList.add('neya-js');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      Array.prototype.forEach.call(els, function (el) {
        var i = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--neya-d', Math.min(Math.max(i, 0), 4) * 90 + 'ms');
        el.classList.add('neya-reveal');
        io.observe(el);
      });
    }
  }

  /* 3. Cartes produit : photo de dos au survol (souris uniquement) */
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches && window.fetch) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var prepare = function (a) {
      if (a.__neyaSwap) return;
      a.__neyaSwap = true;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      fetch(root + 'products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) {
        var u = p.images && p.images[2];
        if (!u) return;
        var im = new Image();
        im.className = 'neya-swap'; im.alt = ''; im.decoding = 'async';
        im.onload = function () {
          a.insertBefore(im, a.querySelector('span'));
          a.classList.add('has-swap');
        };
        im.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=720';
      }).catch(function () {});
    };
    Array.prototype.forEach.call(document.querySelectorAll('.neya-product-card__media'), function (a) {
      a.addEventListener('mouseenter', function () { prepare(a); }, { once: true });
      a.addEventListener('focus', function () { prepare(a); }, { once: true });
    });
  }
})();
